import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUserPlus, FaTrash, FaCopy, FaCheckCircle, FaLink } from "react-icons/fa";
import "../styles/circuitoDesignSystem.css"; // Reaproveitando o design bonito

export default function AfiliadosAdmin() {
  const [eventos, setEventos] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState("");
  const [afiliados, setAfiliados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ nome: "", codigo: "", telefone: "" });
  const [copiadoId, setCopiadoId] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    axios.get("https://api.ticketdovaqueiro.com/api/events", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setEventos(res.data)).catch(console.error);
  }, []);

  useEffect(() => {
    if (eventoSelecionado) buscarAfiliados();
    else setAfiliados([]);
  }, [eventoSelecionado]);

  const buscarAfiliados = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/eventos-afiliados/${eventoSelecionado}/afiliados`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAfiliados(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSalvar = async (e) => {
    e.preventDefault();
    if (!eventoSelecionado) return alert("Selecione um evento primeiro!");
    setLoading(true);
    try {
      await axios.post(`https://api.ticketdovaqueiro.com/api/eventos-afiliados/${eventoSelecionado}/afiliados`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setForm({ nome: "", codigo: "", telefone: "" });
      buscarAfiliados();
    } catch (err) {
      alert(err.response?.data?.error || "Erro ao salvar afiliado");
    } finally {
      setLoading(false);
    }
  };

  const deletarAfiliado = async (id) => {
    if (!window.confirm("Remover este afiliado? (As vendas passadas não serão apagadas)")) return;
    await axios.delete(`https://api.ticketdovaqueiro.com/api/eventos-afiliados/${eventoSelecionado}/afiliados/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    buscarAfiliados();
  };

  const copiarLink = (codigo, id) => {
    const baseUrl = window.location.origin;
    navigator.clipboard.writeText(`${baseUrl}/evento/${eventoSelecionado}/?ref=${codigo}`);
    setCopiadoId(id);
    setTimeout(() => setCopiadoId(null), 2000);
  };

  return (
    <div style={{ padding: "40px", maxWidth: "1200px", margin: "0 auto", marginLeft: "260px", color: "#fff" }}>
      <div style={{ marginBottom: "30px" }}>
        <h1 style={{ fontSize: "28px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}><FaLink color="var(--c-accent)"/> Afiliados por Evento</h1>
        <p style={{ color: "#888" }}>Crie links para promoters divulgarem a vaquejada e ganhe rastreio de vendas.</p>
      </div>

      <div className="pc-card" style={{ marginBottom: "30px", background: "#111", border: "1px solid #333", padding: "20px", borderRadius: "12px" }}>
        <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold" }}>1. Selecione a Vaquejada</label>
        <select className="c-input" style={{ width: "100%", height: "45px" }} value={eventoSelecionado} onChange={e => setEventoSelecionado(e.target.value)}>
            <option value="">-- Escolha um evento --</option>
            {eventos.map(ev => <option key={ev._id} value={ev._id}>{ev.nome}</option>)}
        </select>
      </div>

      {eventoSelecionado && (
        <>
          <form onSubmit={handleSalvar} className="pc-card" style={{ marginBottom: 32, display: "grid", gap: 16, background: "#171717", padding: "20px", borderRadius: "12px" }}>
            <h3 style={{ fontSize: 16, margin: 0, color: "#fff" }}>Cadastrar Novo Promoter/Afiliado</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "#aaa" }}>Nome do Afiliado *</label>
                <input type="text" required value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} className="c-input" placeholder="Ex: João Vaqueiro" style={{ width: "100%" }} />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "#aaa" }}>Código na URL (sem espaços) *</label>
                <input type="text" required value={form.codigo} onChange={e => setForm({...form, codigo: e.target.value.toLowerCase().replace(/\s+/g, "-")})} className="c-input" placeholder="Ex: joao-vaqueiro" style={{ width: "100%" }} />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontSize: 13, color: "#aaa" }}>WhatsApp (Opcional)</label>
                <input type="text" value={form.telefone} onChange={e => setForm({...form, telefone: e.target.value})} className="c-input" placeholder="(00) 00000-0000" style={{ width: "100%" }} />
              </div>
            </div>
            <button type="submit" disabled={loading} className="c-btn c-btn--primary" style={{ width: "200px", height: "45px" }}>
              <FaUserPlus /> {loading ? "Salvando..." : "Criar Afiliado"}
            </button>
          </form>

          <div className="pc-card" style={{ background: "#171717", padding: "20px", borderRadius: "12px" }}>
            <h3 style={{ fontSize: 16, marginBottom: 16, color: "#fff" }}>Afiliados deste evento</h3>
            <div style={{ overflowX: "auto" }}>
              <table className="pc-table" style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #333", color: "#aaa" }}>
                    <th style={{ padding: "10px" }}>Nome</th>
                    <th style={{ padding: "10px" }}>Link de Divulgação</th>
                    <th style={{ padding: "10px", textAlign: "center" }}>Senhas Pagas</th>
                    <th style={{ padding: "10px", textAlign: "right" }}>Total (R$)</th>
                    <th style={{ padding: "10px", textAlign: "center" }}>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {afiliados.length === 0 ? (
                    <tr><td colSpan="5" style={{ textAlign: "center", padding: 30, color: "#555" }}>Nenhum afiliado neste evento.</td></tr>
                  ) : (
                    afiliados.map(af => (
                      <tr key={af._id} style={{ borderBottom: "1px solid #222" }}>
                        <td style={{ padding: "10px" }}><strong>{af.nome}</strong></td>
                        <td style={{ padding: "10px" }}>
                            <button onClick={() => copiarLink(af.codigo, af._id)} style={{ background: "rgba(59, 130, 246, 0.1)", color: copiadoId === af._id ? "#10b981" : "#3b82f6", border: "none", padding: "6px 12px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
                              {copiadoId === af._id ? <FaCheckCircle /> : <FaCopy />} Copiar Link
                            </button>
                        </td>
                        <td style={{ padding: "10px", textAlign: "center", color: "#3b82f6", fontWeight: "bold" }}>{af.qtdVendas}</td>
                        <td style={{ padding: "10px", textAlign: "right", color: "#10b981", fontWeight: "bold" }}>R$ {Number(af.valorArrecadado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                        <td style={{ padding: "10px", textAlign: "center" }}>
                          <button onClick={() => deletarAfiliado(af._id)} style={{ background: "transparent", color: "#ef4444", border: "none", cursor: "pointer", fontSize: "16px" }}><FaTrash /></button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}